import { useLocation } from '@reach/router';
import { useIntl } from 'react-intl';

import { SeoBreadcrumb } from '@xing-com/seo-breadcrumb';

import { useCompaniesRoutes } from '../../hooks/use-companies-routes/use-companies-routes';
import { getCrumbs } from '../../routes/getCrumbs';
import type { CompaniesRoute } from '../../types';
import * as Styled from './breadcrumbs.styles';

type BreadcrumbsProps = {
  routes?: CompaniesRoute[];
  overriteNames?: { [route: string]: () => string };
};
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  routes,
  overriteNames,
}) => {
  const location = useLocation();
  const pathname = location?.pathname;
  const searchParams = Object.fromEntries(
    new URLSearchParams(location?.search)
  );
  const { routes: companiesRoutes } = useCompaniesRoutes();
  const routesApp = routes ?? companiesRoutes;

  const { formatMessage } = useIntl();

  const firstCrumb = {
    url: '/',
    title: formatMessage({ id: 'XDS_BREADCRUMB_HOME' }),
  };

  const crumbs = getCrumbs(routesApp, pathname, searchParams, overriteNames);

  const allBreadcrumbs = [firstCrumb, ...crumbs];

  return (
    <Styled.Wrapper>
      <SeoBreadcrumb items={allBreadcrumbs} />
    </Styled.Wrapper>
  );
};
